import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { EmptySlate, Link } from "@activecollab/components";
import PropTypes from "prop-types";
import { getLoggedUserId } from "~/store/selectors/selector.users";
import Angie from "~/utils/angie";

export const UserTasksEmptySlate = ({ userId }) => {
  const { t } = useTranslation();
  const loggedUserId = useSelector(getLoggedUserId);

  return (
    <EmptySlate
      className="tw-h-full"
      src={`${Angie.assets_url}/system/images/layout/my_tasks_empty_page.png`}
      alt="my_work_empty_page"
      title={`${t("No Assigned Tasks")}`}
      description={`${t(
        `Every task ${userId && loggedUserId !== userId ? "user is " : "you're "} assigned to will show up here`
      )}.`}
    >
      <EmptySlate.Footer>
        <Link
          className="tw-mb-6"
          href="https://activecollab.com/help/books/projects/tasks"
          variant="text link-gray"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("Organize your work")}
        </Link>
      </EmptySlate.Footer>
    </EmptySlate>
  );
};

UserTasksEmptySlate.propTypes = {
  userId: PropTypes.number,
};
